import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'mmx-overlap-icon',
  templateUrl: './overlap-icon.component.html',
  styleUrls: ['./overlap-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
  ],
})
export class OverlapIconComponent {
  @Input()
  public icon: string = ''

  @Input()
  public primaryColor: string = ''

  @Input()
  public secondaryColor: string = ''
}
